import React, {FormEvent, SyntheticEvent} from "react";
import {AlertOptions} from "@ionic/react";
import AppComponent from "../AppComponent";
import ApiResponseVO from "../../../ts/manager/api/ApiResonseVO";
import {ucFirst} from "../../../ts/common/SiteHelper";
import ApiError, {determineLineErrors} from "../../../ts/manager/api/ApiError";
import {nbsp} from "../../../ts/common/Constants";
import {getManager} from "../../../ts/manager/Manager";
import {IAnyObject} from "../../../ts/common/SimpleInterface";
import {
    BooleanFormItem,
    DateFormItem,
    FileFormItem,
    FloatFormItem,
    FormItem,
    FormItemType,
    IBooleanFormItemProps,
    IDateFormItemProps,
    IFileFormItemProps,
    IFloatFormItemProps, IPointer,
    IFormItemProps,
    IFormItems,
    IFormProps,
    IIntFormItemProps,
    INoneFormItemProps,
    IntFormItem,
    IStringFormItemProps,
    NoneFormItem,
    StringFormItem, RepeaterFormItem, IRepeaterFormItemProps, ArrayFormItem, IArrayFormItemProps,
    IMapLocationFormItemProps, MapLocationFormItem, IGroupFormItemProps, GroupFormItem
} from "./model/FormModel";
import AlertFE from "./form-element/AlertFE";
import {
    createChildPointer,
    createChildIndexPointer,
    getFinalChildPointer,
    getParentPointer,
    preparedPointer, removeParentFromPointer
} from "./helper/PointerHelper";
import eventBus from "../../../ts/event/EventBus";
import FormSubmitVO from "./model/vo/FormSubmitVO";
import {PostFieldSubmitTab} from "../../../ts/manager/config/PostFieldConfig";

export default class BasicForm extends AppComponent<IFormProps>
{

    props: IFormProps;

    invalid: boolean = false;
    formDidSubmit: boolean = false;
    localInvalid: boolean = false;
    apiInvalid: boolean = false;
    isDisabledExternally: boolean = false;

    formItems: IFormItems = {};
    currentValues:IAnyObject = {};
    applyingCurrentValuesCount: number = 0;
    maxApplyingCurrentValuesCount: number = 5;
    onValueRenderCallbacks:(() => void)[] = [];
    hideSuccessMessage:boolean = false;
    successMessage:string = "";
    defaultSuccessMessage:string = "Successfully submitted";
    primaryErrorMessage:string = "Submission error";
    singleErrorMessage:string = "There is an error is your submission:";
    multipleErrorsMessage:string = "There are some errors is your submission:";
    hideGeneralMessagesOnClick:boolean = false;
    lastGeneralMessagesSetAt:Date|null = null;
    proceedIfFileInvalid:boolean = false;
    formWillRefresh = false;

    constructor(props: IFormProps)
    {
        super(props);

        this.props = props;
    }

    bindFunctions(): void
    {
        super.bindFunctions()

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeItemSubmit = this.handleChangeItemSubmit.bind(this);
        this.resetFormItems = this.resetFormItems.bind(this);
        this.callCancel = this.callCancel.bind(this);
        this.checkRemoveGeneralMessages = this.checkRemoveGeneralMessages.bind(this);
    }

    onInitialize(): void
    {
        super.onInitialize();
        this.applyDebugValues();
    }

    applyDebugValues(): void
    {

    }

    getFormEventSubmitType(event?: SyntheticEvent): string
    {
        let submitType:string|null|undefined = null;
        if (event && event.target && (event.target instanceof HTMLFormElement))
        {
            submitType = (event.nativeEvent as SubmitEvent).submitter?.getAttribute('value')
        }
        return submitType ? submitType : "submit";
    }

    getFormItemSubmitType(_:string): string
    {
        return "submit";
    }

    onFormItemChange(_:string|string[]): void
    {
        this.applyActiveFormItems();
        if(this.localInvalid){
            if(!this.apiInvalid){
                this.errorTexts.length = 0;
            }
            this.validateFormItems();
            this.findSubmissionErrors();
        }
        this.formDidSubmit = false;
        this.successMessage = "";
        this.didSubmit = false;
        this.props.onAction && this.props.onAction();
        this.refreshState(true);
    }

    handleChangeItemSubmit(formItemID:string): void
    {
        this.applyActiveFormItems();

        const formItem = this.formItems[formItemID];
        if(!formItem?.active)
        {
            return;
        }
        const submitType = this.getFormItemSubmitType(formItemID);
        this.props.onAction && this.props.onAction();
        const previousValue = formItem.previousValue;
        this.renderAndSubmit(submitType, [formItem.itemID], (success: boolean) => {
            if (!this.formDidSubmit)
            {
                formItem.setValue(previousValue)
                this.refreshState()
            }
            return success
        })
    }

    renderAndSubmit(submitType: string|null = null, formItemIDs: string[]|null = null, callback:((success:boolean) => void)|null = null):void
    {
        this.setLoading(true);
        this.formDidSubmit = false;
        this.successMessage = "";
        this.didSubmit = false;

        this.addValueRenderCallback(() => {
            this.processFormSubmit(submitType, formItemIDs).then((success: boolean) =>{
                if(callback){
                    callback(success)
                }
            })
        });
    }

    handleFormSubmit(event: SyntheticEvent): void
    {
        event.preventDefault();

        let submitType = this.getFormEventSubmitType(event);

        this.processFormSubmit(submitType).then();
    }

    isFormItemHidden(formItem:FormItem|PostFieldSubmitTab): boolean
    {
        return false
    }

    applyActiveFormItems(): void
    {
        for(let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            formItem.active = !formItem.isPlaceholder && !this.isFormItemHidden(formItem) && !!this.getFormItemElement(formItem.pointer.itemID ?? "");
            formItem.canSubmit = formItem.active;
            formItem.willSubmitEmpty = formItem.returnEmpty;
        }

        let checkCanSubmit = true;
        while(checkCanSubmit){
            checkCanSubmit = false;
            for(let formItemID in this.formItems)
            {
                const formItem = this.formItems[formItemID];
                if(formItem.canSubmit){
                    continue;
                }
                let activateOnSubmit = formItem.activateOnSubmit;
                if(!activateOnSubmit && formItem.activatedByItemID){
                    const altItem = this.formItems[formItem.activatedByItemID];
                    if(altItem?.canSubmit){
                        activateOnSubmit = true;
                    }
                }
                if(activateOnSubmit){
                    formItem.canSubmit = true;
                    checkCanSubmit = true;
                }
            }
        }

        for(let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            if(formItem.doNotSubmit || formItem.isPlaceholder){
                formItem.canSubmit = false;
            }
        }
    }

    prepareFormSubmit(formItemIDs: string[]|null = null): void
    {
        this.setLoading(true);
        this.errorTexts.length = 0;
        this.lastGeneralMessagesSetAt = null;
        this.applyActiveFormItems();
        this.initSubmitState();
        this.validateFormItems(formItemIDs);

        this.apiInvalid = false;
        this.invalid = this.localInvalid;
        if (!this.invalid)
        {
            this.handleCurrentlyValid();
        } else {
            this.onProcessFormHalt();
        }
    }

    async processFormSubmit(submitType: string|null = null, formItemIDs: string[]|null = null): Promise<boolean>
    {

        submitType = submitType ?? "submit";
        if((submitType === "delete") && (formItemIDs === null)){
            formItemIDs = [];
        }
        this.prepareFormSubmit(formItemIDs);
        if(this.invalid)
        {
            return false;
        }

        return this.handleConfirmations(submitType, formItemIDs).then((doContinue: boolean) =>
        {
            if (!doContinue)
            {
                this.onProcessFormHalt();
                return false;
            }

            return this.handleSubmit(submitType, formItemIDs).then((responseVO: ApiResponseVO) =>
            {
                this.setLoading(false);
                if (responseVO.apiError)
                {
                    this.invalid = true;
                    this.apiInvalid = true;
                    const errorItemIDs = Object.keys(responseVO.apiError.lineErrors);
                    if (!this.customError(responseVO))
                    {
                        let haveItemErrors = false;
                        const defaultErrorMessage = responseVO.apiError.message ? responseVO.apiError.message : "Unknown Error";
                        const singleFormItem = formItemIDs && formItemIDs.length === 1 ? (this.formItems[formItemIDs[0]] ?? null) : null;
                        if (singleFormItem && singleFormItem.active && !Object.keys(responseVO.apiError.lineErrors).length)
                        {
                            const dataErrors:IAnyObject = {};
                            dataErrors[singleFormItem.itemID] = defaultErrorMessage;
                            responseVO.apiError.lineErrors = determineLineErrors(dataErrors)
                        }

                        let generalErrorAdded = false;
                        for (let formItemID in responseVO.apiError.lineErrors)
                        {
                            const lineError = responseVO.apiError.lineErrors[formItemID];
                            const errors = lineError.errors;

                            if (errors.length)
                            {
                                haveItemErrors = true;
                                for (let i = 0; i < errors.length; i++)
                                {
                                    let error = errors[i];
                                    let formItem = this.formItems[formItemID];
                                    const searchFor = "[field_name]";
                                    let doUcFirst = error.startsWith(searchFor);
                                    let itemName = formItem?.name;
                                    if (itemName)
                                    {
                                        itemName = itemName.toLowerCase();
                                    } else
                                    {
                                        itemName = lineError.fieldID;
                                        doUcFirst = false;
                                    }
                                    if (itemName)
                                    {
                                        errors[i] = errors[i].split(searchFor).join(itemName);
                                        if (doUcFirst)
                                        {
                                            errors[i] = ucFirst(errors[i]);
                                        }
                                    }
                                }
                                let formItem = this.formItems[formItemID];
                                if (formItem && this.getFormItemErrorHandlerElement(formItem.itemID))
                                {
                                    formItem.errorText = errors[0];
                                    if (!generalErrorAdded)
                                    {
                                        generalErrorAdded = true;
                                    }
                                } else
                                {
                                    this.errorTexts = (this.errorTexts).concat(errors);
                                }
                            }
                        }
                        if (!haveItemErrors)
                        {
                            this.errorTexts = [defaultErrorMessage];
                        }
                    }
                    return this.onSubmitFailed(responseVO, submitType, formItemIDs).then(() => {
                        if(errorItemIDs.length){
                            this.removeRedundantFormItems(formItemIDs, errorItemIDs);
                        }
                        this.onProcessFormHalt();
                        return false;
                    })
                }

                this.formDidSubmit = true;
                this.successMessage = this.defaultSuccessMessage;
                this.didSubmit = true;

                return this.getAdditionalData(responseVO, submitType, formItemIDs).then(() =>
                {
                    this.didSubmit = true;

                    this.removeRedundantFormItems(formItemIDs);
                    this.resetFormItems();
                    this.onProcessFormHalt();
                    this.handleSubmitComplete(responseVO, submitType, formItemIDs);
                    this.props.onSubmit && this.props.onSubmit(submitType);
                    this.formWillRefresh = true;
                    return true;
                }).catch((error: ApiError | string) =>
                {
                    this.invalid = true;
                    this.apiInvalid = true;
                    this.errorTexts = [error instanceof ApiError ? error.message : error];
                    this.onProcessFormHalt();
                    return false;
                })
            });
        })

    }

    onPostRender()
    {
        super.onPostRender();
        this.applyCurrentValues();
    }

    applyCurrentValues(): void
    {
        const currentValues: IAnyObject = {};
        for (let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            if(!formItem.active){
                continue;
            }
            currentValues[formItem.itemID] = formItem.getCompareValue(formItem.value);
        }
        let didChange = false;
        if(this.applyingCurrentValuesCount < this.maxApplyingCurrentValuesCount){
            didChange = Object.keys(currentValues).length !== Object.keys(this.currentValues).length;
            if(!didChange){
                for(let key in currentValues){
                    if(!this.currentValues.hasOwnProperty(key) || (currentValues[key] !== this.currentValues[key])){
                        didChange = true;
                        break;
                    }
                }
            }
        }
        if(didChange){
            this.currentValues = currentValues;
            this.applyingCurrentValuesCount ++;
            setTimeout(() => {
                this.refreshState();
            }, 1);
        } else if(this.applyingCurrentValuesCount) {
            this.applyingCurrentValuesCount = 0;
            setTimeout(() => {
                if(!this.applyingCurrentValuesCount && this.mounted){
                    this.onValueRender();
                }
            }, 1);
        }
    }


    addValueRenderCallback(callback: () => void): void
    {
        this.applyingCurrentValuesCount = 1;
        this.onValueRenderCallbacks.push(callback);
        this.refreshState();
    }

    onValueRender(): void
    {
        for(let callback of this.onValueRenderCallbacks){
            callback();
        }
        this.onValueRenderCallbacks.length = 0;
    }

    onProcessFormHalt(): void
    {
        this.setLoading(false);
        for (let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            formItem.canSubmit = false;
        }
        this.findSubmissionErrors();
        this.refreshState();
    }

    findSubmissionErrors(): void
    {
        let errorTexts:string[] = [];
        for (let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            if(formItem.active && formItem.errorText){
                errorTexts.push(formItem.errorText);
            }
        }
        if(errorTexts.length){
            if(errorTexts.length === 1){
                this.errorTexts.push( this.singleErrorMessage);
            } else {
                this.errorTexts.push( this.multipleErrorsMessage);
            }
            for(let message of errorTexts){
                this.errorTexts.push(message);
            }
            
        }
    }

    getFormItemElement(formItemID: string): Element|null
    {
        const element =  this.getForm()?.querySelector('[data-form-item-id="' + formItemID + '"]') ?? null;
        if(element){
            return element;
        }
        const altElement =  this.getForm()?.querySelector('[data-alt-form-item-id="' + formItemID + '"]') ?? null;
        if(!altElement){
            return null;
        }
        return altElement.closest('[data-form-item-id]') ?? null;
    }

    getFormItemErrorHandlerElement(formItemID: string): Element|null
    {
        const element = this.getForm()?.querySelector('[data-error-for-form-item-id="' + formItemID + '"]') ?? null;
        if(element){
            return element;
        }
        const altElement =  this.getForm()?.querySelector('[data-error-for-alt-form-item-id="' + formItemID + '"]') ?? null;
        if(!altElement){
            return null;
        }

        return altElement.closest('[data-error-for-form-item-id]') ?? null;
    }

    requiredFieldsMessage(): React.JSX.Element
    {
        this.applyActiveFormItems();

        let isRequired = false;
        for (let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            if(formItem.active && formItem.required){
                isRequired = true;
            }
        }
        return <p className="small">

            {isRequired ? <><span className="required"></span>{nbsp}Required field</> : nbsp}
        </p>;
    }

    doShowAlerts()
    {
        return !!this.errorTexts.length || (!this.hideSuccessMessage && !!this.successMessage);
    }

    startFormAlerts(): React.JSX.Element
    {
        if(!this.errorTexts.length){
            return <></>;
        }
        return <AlertFE
            onCloseCallback={() =>
            {
                this.errorTexts.length = 0
                this.refreshState();
            }}
            message={this.errorTexts}
        />;
    }

    endFormAlerts(): React.JSX.Element
    {
        if(!this.doShowAlerts()){
            return <></>;
        }
        if(this.hideGeneralMessagesOnClick && !this.lastGeneralMessagesSetAt)
        {
            this.lastGeneralMessagesSetAt = new Date();
        }
        return <>
            {!!this.errorTexts.length && <AlertFE
                onCloseCallback={() =>
                {
                    this.errorTexts.length = 0
                    this.refreshState();
                }}
                message="There are some errors is your submission"
            />}
            {!this.hideSuccessMessage && !!this.successMessage && <AlertFE
                message={this.successMessage}
                onCloseCallback={() =>
                {
                    this.successMessage = "";
                    this.refreshState();
                }}
                elementProps={{
                    className:"alert-success"
                }}
            />}
        </>
    }

    formAlerts(): React.JSX.Element
    {
        if(!this.doShowAlerts()){
            return <></>;
        }
        if(this.hideGeneralMessagesOnClick && !this.lastGeneralMessagesSetAt)
        {
            this.lastGeneralMessagesSetAt = new Date();
        }
        return <>
            {!!this.errorTexts.length && <AlertFE
                onCloseCallback={() =>
                {
                    this.errorTexts.length = 0
                    this.refreshState();
                }}
                message={this.errorTexts}
            />}
            {!this.hideSuccessMessage && !!this.successMessage && <AlertFE
                message={this.successMessage}
                onCloseCallback={() =>
                {
                    this.successMessage = "";
                    this.refreshState();
                }}
                elementProps={{
                    className:"alert-success"
                }}
            />}
        </>
    }

    customError(responseVO: ApiResponseVO): boolean
    {
        return false;
    }

    handleCurrentlyValid(): void
    {
        this.errorTexts.length = 0;
    }

    async onSubmitFailed(responseVO: ApiResponseVO, submitType: string, formItemIDs: string[]|null): Promise<void>
    {

    }

    async getAdditionalData(responseVO: ApiResponseVO, submitType: string, formItemIDs: string[]|null): Promise<void>
    {

    }

    handleSubmitComplete(responseVO: ApiResponseVO, submitType: string, formItemIDs: string[]|null)
    {

    }

    async handleConfirmations(submitType: string, formItemIDs: string[]|null): Promise<boolean>
    {
        return new Promise<boolean>((resolve) =>
        {
            const confirmationOptions = this.confirmationOptions(resolve, submitType, formItemIDs);
            if (!confirmationOptions)
            {
                resolve(true);
                return;
            }
            return getManager().ui.showAlert(confirmationOptions!)

        });
    }


    confirmationOptions(resolve: ((value: (boolean | PromiseLike<boolean>)) => void), submitType: string, formItemIDs: string[]|null): AlertOptions | null
    {
        return null;
    }

    async handleSubmit(submitType: string, formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const fileFormItems: FileFormItem[] = [];
        for (let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            if(formItemIDs && !formItemIDs.includes(formItemID))
            {
                continue;
            }
            if(formItem.type === "file"){
                const fileFormItem = formItem as FileFormItem;
                if(fileFormItem.willAddFiles()){
                    fileFormItems.push(fileFormItem);
                }
            }
        }
        let fileErrorResponseVO: ApiResponseVO | null = null;

        for (let formItem of fileFormItems)
        {
            const fileResponseVO = await this.handleSubmitFileItem(formItem, submitType);
            if (fileResponseVO.apiError)
            {
                if(!this.proceedIfFileInvalid){
                    return fileResponseVO;
                }
                fileErrorResponseVO = fileErrorResponseVO ?? fileResponseVO;
            }
        }

        let responseVO:ApiResponseVO
        if(submitType !== "delete"){
            responseVO = await this.handleSubmitItems(formItemIDs, submitType);
        } else {
            responseVO = await this.handleDelete();
        }
        if (responseVO.apiError)
        {
            return responseVO;
        }

        return fileErrorResponseVO?.apiError ? fileErrorResponseVO : responseVO;
    }

    async handleSubmitFileItem(formItem: FileFormItem, submitType: string): Promise<ApiResponseVO>
    {
        return new ApiResponseVO();
    }

    async handleSubmitItems(formItemIDs: string[]|null, submitType: string): Promise<ApiResponseVO>
    {
        return new ApiResponseVO();
    }


    async handleDelete(): Promise<ApiResponseVO>
    {
        return new ApiResponseVO();
    }

    collectParams(formItemIDs: string[]|null): IAnyObject
    {
        const params: IAnyObject = {};
        const addToParams = (pointer:IPointer, toParams:IAnyObject, value:any) =>
        {
            if(pointer.collectionType === "single"){
                toParams[pointer.fieldID] = value;
                return;
            }
            if(!pointer.childPointer){
                return;
            }
            let object:IAnyObject = {}

            if(pointer.collectionType === "group_object"){
                object = typeof toParams[pointer.fieldID] === 'object' ? toParams[pointer.fieldID] : object;
                toParams[pointer.fieldID] = object;
                addToParams(pointer.childPointer, object, value);
            } else if(pointer.collectionType === "group_array"){
                const index = pointer.index ?? 0;
                let array = Array.isArray(toParams[pointer.fieldID]) ? toParams[pointer.fieldID] : [];
                toParams[pointer.fieldID] = array;
                for(let i = array.length; i < index; i++){
                    array[i] = null;
                }
                object = typeof array[index] === 'object' ? array[index] : object;
                array[index] = object;
                addToParams(pointer.childPointer, object, value);
            } else if(pointer.collectionType === "id_array" && pointer.childPointer && value){
                const parentArray = Array.isArray(toParams[pointer.fieldID]) ? toParams[pointer.fieldID] : [];
                if(!parentArray.includes(pointer.childPointer.fieldID)){
                    parentArray.push(pointer.childPointer.fieldID);
                }
                toParams[pointer.fieldID] = parentArray;
            }
        }

        const ignoreTypes: FormItemType[] = ["group", "repeater"]
        for (let formItemID in this.formItems)
        {

            const formItem = this.formItems[formItemID];
            if ((formItemIDs && !formItemIDs.includes(formItemID)) || ignoreTypes.includes(formItem.type))
            {
                continue;
            }
            let value = formItem.getSubmitValue();
            value = value instanceof FormSubmitVO ? value.getSubmitValue() : value;
            if(value !== null){
                addToParams(formItem.pointer, params, value);
            }
        }
        return params;
    }

    validateFormItems(inFormItemsIDs: string[]|null = null): void
    {
        let localInvalid = false;
        let haveAnyActive = false;
        for (let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            const localError = (!inFormItemsIDs || inFormItemsIDs.includes(formItemID)) && formItem.active ? this.getLocalError(formItem) : null;
            if (localError)
            {
                formItem.errorText = localError;
                formItem.hasLocalError = true;
                localInvalid = true;
            } else if(formItem.hasLocalError){
                formItem.errorText = "";
                formItem.hasLocalError = false;
            }
            if(formItem.active){
                haveAnyActive = true;
            }
        }
        this.localInvalid = localInvalid || (!!inFormItemsIDs && !haveAnyActive);
    }

    getLocalError(formItem: FormItem): string|null
    {
        if(formItem.required)
        {
            if (formItem.isEmpty())
            {
                return formItem.errorMessages?.required ?? formItem.name + " is required";
            }
        }
        return null;
    }

    canReset(): boolean
    {
        for(let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            if(formItem.canReset()){
                return true;
            }
        }
        return false;
    }

    removeRedundantFormItems(formItemIDs: string[]|null, errorItemIDs:string[] = [])
    {

        const relevantFormItemArray:FormItem[] = [];

        for(let formItemID in this.formItems)
        {
            if (formItemIDs && !formItemIDs.includes(formItemID))
            {
                continue;
            }
            const formItem = this.formItems[formItemID] ?? null;
            if(!formItem){
                continue;
            }

            let hasErrors = false;
            for(let errorItemID of errorItemIDs){
                if(errorItemID.startsWith(formItem.itemID) || formItem.itemID.startsWith(errorItemID)){
                    hasErrors = true;
                    break;
                }
            }
            if(hasErrors){
                continue;
            }
            relevantFormItemArray.push(formItem);
        }

        let willDeletePointers:IPointer[] = [];

        for(let formItem of relevantFormItemArray)
        {
            if(formItem.deleteOnSubmit && !willDeletePointers.includes(formItem.pointer)){
                willDeletePointers.push(formItem.pointer)
            }
            if(formItem.getSubmitValue() !== null)
            {

                for(let formItemID of formItem.willDeleteItemIDs){
                    const altFormItem = this.formItems[formItemID] ?? null;
                    if(altFormItem && !willDeletePointers.includes(altFormItem.pointer)){
                        willDeletePointers.push(altFormItem.pointer)
                    }
                }
            }
        }
        for(let pointer of willDeletePointers)
        {
            this.deleteFormItem(pointer);
        }
    }

    resetFormItems()
    {
        this.addValueRenderCallback(() => {
            for(let formItemID in this.formItems)
            {
                const formItem = this.formItems[formItemID];
                formItem.doReset()
            }
            this.refreshState();
        })
    }

    isSubmitDisabled(): boolean
    {
        return this.isDisabled();
    }

    isDisabled(): boolean
    {
        return super.isDisabled() || this.isDisabledExternally;
    }

    determineIsDisabledExternally(): void
    {
        const isDisabledExternally = getManager().api.hasOpenFetchRequest();
        if(isDisabledExternally !== this.isDisabledExternally){
            this.isDisabledExternally = isDisabledExternally;
            this.onDisabledStateChange();
        }
    }

    getFormItemArray(parentPointer: IPointer|string):FormItem[]
    {
        parentPointer = preparedPointer(parentPointer);
        const formItemArray: FormItem[] = [];
        let nextIndex = -1;
        while(true)
        {
            nextIndex ++;
            const childPointer = createChildIndexPointer(nextIndex, parentPointer);
            const formItem = this.formItems[childPointer.itemID!] ?? null;
            if(!formItem){
                break;
            }
            formItemArray.push(formItem)
        }
        return formItemArray;
    }

    addToFormItemArray(parentPointer: IPointer|string, deleteOnSubmit:boolean = false):void
    {
        parentPointer = preparedPointer(parentPointer);
        const formItemArray = this.getFormItemArray(parentPointer);
        const childPointer = createChildIndexPointer(formItemArray.length, parentPointer);
        let formItem = this.formItems[childPointer.itemID!];
        if(formItem?.pointer.collectionType !== "group_array"){
            formItem = this.noneItem(childPointer)
        }
        if(deleteOnSubmit){
            formItem.deleteOnSubmit = true;
        }
        this.refreshState();
    }

    deleteFormItem(pointer: IPointer)
    {
        pointer = preparedPointer(pointer);
        if(pointer.collectionType === "group_object"){
            this.deleteFormItemGroupObject(pointer);
        } else if(pointer.collectionType === "group_array"){
            this.deleteFormItemGroupArray(pointer);
        } else {
            delete this.formItems[pointer.itemID!];
        }
    }

    deleteFormItemGroupObject(pointer: IPointer)
    {
        pointer = preparedPointer(pointer);

        for(let formItemID in this.formItems)
        {
            const formItem = this.formItems[formItemID];
            if (!formItem.itemID.startsWith(pointer.itemID!))
            {
                continue;
            }
            delete this.formItems[formItemID];
        }
    }


    applyNewItemGroupArrayOrder(pointer: IPointer, order:number[])
    {
        pointer = preparedPointer(pointer);
        const itemID = pointer.itemID;
        const ofArrayItems:FormItem[] = [];
        const descendantItems:FormItem[][] = [];
        let nextIndex:number = -1;
        while(true){
            nextIndex ++;
            const nextID = itemID+", index: "+nextIndex;
            const existingItem = this.formItems[nextID];
            if(!existingItem){
                break;
            }
            ofArrayItems.push(existingItem);
            delete this.formItems[nextID];
            descendantItems.push([]);
            for(let checkItemID in this.formItems){
                if(checkItemID.startsWith(nextID+" ") || checkItemID.startsWith(nextID+", ")){
                    descendantItems[nextIndex].push(this.formItems[checkItemID])
                    delete this.formItems[checkItemID];
                }
            }
        }
        let newIndex = -1;
        for(let oldIndex of order){
            const arrayItem = ofArrayItems[oldIndex];
            if(!arrayItem){
                continue;
            }
            newIndex ++;
            const oldPointer = arrayItem.pointer;
            const newPointer = createChildIndexPointer(newIndex, pointer);
            arrayItem.reapplyPointer(newPointer);
            this.formItems[arrayItem.itemID] = arrayItem;

            const thisDescendantItems = descendantItems[oldIndex] ?? [];
            for(let descendantItem of thisDescendantItems){
                const withPointer = removeParentFromPointer(descendantItem.pointer, oldPointer)
                if(withPointer){
                    const newDescendantPointer = createChildPointer(withPointer, newPointer)
                    descendantItem.reapplyPointer(newDescendantPointer);
                    this.formItems[descendantItem.itemID] = descendantItem;
                }
            }
        }
    }

    deleteFormItemGroupArray(pointer: IPointer)
    {
        pointer = preparedPointer(pointer);
        const finalChildPointer = getFinalChildPointer(pointer);
        const parentPointer = getParentPointer(pointer)
        let fromIndex = finalChildPointer.index ?? null;
        if((fromIndex === null) || !parentPointer){
            return;
        }
        let nextIndex = fromIndex;
        let previousRelevantPointer:IPointer|null = null;
        const toAdd:FormItem[] = [];
        while(true){
            const thisIndex = nextIndex;
            nextIndex ++;
            const relevantPointer = thisIndex === fromIndex ? pointer : createChildIndexPointer(thisIndex, parentPointer);

            let anyFound = false;
            for(let formItemID in this.formItems)
            {
                const formItem = this.formItems[formItemID];
                if(!formItem.itemID.startsWith(relevantPointer.itemID!)){
                    continue;
                }
                if(thisIndex !== fromIndex){
                    const childPointer = removeParentFromPointer(formItem.pointer, relevantPointer);
                    const newPointer = childPointer ? createChildPointer(childPointer, previousRelevantPointer!) : previousRelevantPointer!;
                    formItem.pointer = newPointer;
                    formItem.itemID = newPointer.itemID!;
                    toAdd.push(formItem);
                }
                delete this.formItems[formItemID];
                anyFound = true;
            }
            previousRelevantPointer = relevantPointer;
            if(!anyFound){
                break;
            }
        }
        for(let formItem of toAdd){
            this.formItems[formItem.itemID] = formItem;
        }
        this.refreshState();
    }

    onDisabledStateChange()
    {
        super.onDisabledStateChange();

        this.props.onDisabledStateChange && this.props.onDisabledStateChange(this.isDisabled());
    }

    onUIRefresh()
    {
        super.onUIRefresh();
        this.applyCurrentDisabled();
    }

    applyCurrentDisabled(): void
    {
        const wasDisabled = this.isDisabled();
        this.determineIsDisabledExternally();
        if (this.isDisabled() !== wasDisabled && !getManager().navigation.routeIsProcessing)
        {
            this.refreshState();
        }
    }

    callCancel(): void
    {
        this.props.onCancel && this.props.onCancel();
    }

    getForm(): HTMLFormElement | null
    {
        const componentElement = this.componentElement();
        if (!componentElement)
        {
            return null;
        }
        return componentElement.getElementsByTagName('form')[0] ?? null;
    }

    stringItem(pointer: IPointer|string): StringFormItem
    {
        return this.requirePointer(pointer, "string" ) as StringFormItem;
    }

    floatItem(pointer: IPointer|string): FloatFormItem
    {
        return this.requirePointer(pointer, "float") as FloatFormItem;
    }

    intItem(pointer: IPointer|string): IntFormItem
    {
        return this.requirePointer(pointer, "int") as IntFormItem;
    }

    booleanItem(pointer: IPointer|string): BooleanFormItem
    {
        return this.requirePointer(pointer, "boolean") as BooleanFormItem;
    }

    dateItem(pointer: IPointer|string): DateFormItem
    {
        return this.requirePointer(pointer, "date") as DateFormItem;
    }

    fileItem(pointer: IPointer|string): FileFormItem
    {
        return this.requirePointer(pointer, "file") as FileFormItem;
    }

    mapLocationItem(pointer: IPointer|string): MapLocationFormItem
    {
        return this.requirePointer(pointer, "map_location") as MapLocationFormItem;
    }

    groupItem(pointer: IPointer|string): GroupFormItem
    {
        return this.requirePointer(pointer, "group") as GroupFormItem;
    }

    repeaterItem(pointer: IPointer|string): RepeaterFormItem
    {
        return this.requirePointer(pointer, "repeater") as RepeaterFormItem;
    }

    arrayItem(pointer: IPointer|string): ArrayFormItem
    {
        return this.requirePointer(pointer, "array") as ArrayFormItem;
    }

    noneItem(pointer: IPointer|string): NoneFormItem
    {
        return this.requirePointer(pointer, "none") as NoneFormItem;
    }

    hasFormItem(pointer: IPointer|string): boolean
    {
        pointer = preparedPointer(pointer);
        return !!(this.formItems[pointer.itemID!] ?? false);
    }

    requirePointer(pointer: IPointer|string, type: FormItemType, activate:boolean = false): FormItem
    {
        pointer = preparedPointer(pointer);

        const props:IFormItemProps = {
            pointer: pointer,
            name: "",
            type: type,
            value: "",
            isPlaceholder: true
        }
        return this.requireFormItem(props, type, activate);
    }

    requireFormItem(props: IFormItemProps, type?: FormItemType|null, activate:boolean = false): FormItem
    {
        props.pointer = preparedPointer(props.pointer);
        let formItem:FormItem|null = this.formItems[props.pointer.itemID!] ?? null;
        let haveValidFormItem = false;
        if(formItem && type)
        {
            switch (type)
            {
                case "string":
                    haveValidFormItem = formItem instanceof StringFormItem;
                    break;
                case "float":
                    haveValidFormItem = formItem instanceof FloatFormItem;
                    break;
                case "int":
                    haveValidFormItem = formItem instanceof IntFormItem;
                    break;
                case "boolean":
                    haveValidFormItem = formItem instanceof BooleanFormItem;
                    break;
                case "date":
                    haveValidFormItem = formItem instanceof DateFormItem;
                    break;
                case "file":
                    haveValidFormItem = formItem instanceof FileFormItem;
                    break;
                case "map_location":
                    haveValidFormItem = formItem instanceof MapLocationFormItem;
                    break;
                case "group":
                    haveValidFormItem = formItem instanceof GroupFormItem;
                    break;
                case "repeater":
                    haveValidFormItem = formItem instanceof RepeaterFormItem;
                    break;
                case "array":
                    haveValidFormItem = formItem instanceof ArrayFormItem;
                    break;
                case "none":
                    haveValidFormItem = formItem instanceof NoneFormItem;
                    break;
            }
            if(!haveValidFormItem){
                formItem = null;
            }
        }
        if(formItem){
            if(!props.isPlaceholder && type){
                const wasPlaceHolder = formItem.isPlaceholder;
                const previousDefaultValue = formItem.defaultValue;
                formItem.update(props)

                if(!wasPlaceHolder && !formItem.compareValues(previousDefaultValue, formItem.defaultValue, true)){
                    if(!this.formWillRefresh){
                        this.onFormItemChange(formItem.fieldID)
                    }
                }
            }
            if(activate){
                formItem.active = true;
            }
            return formItem;
        }
        if(!type){
            props = JSON.parse(JSON.stringify(props)) as IFormItemProps;
            props.isPlaceholder = true;
        }
        switch (type)
        {
            case "string":
                formItem = new StringFormItem(props as IStringFormItemProps);
                break;
            case "float":
                formItem = new FloatFormItem(props as IFloatFormItemProps);
                break;
            case "int":
                formItem = new IntFormItem(props as IIntFormItemProps);
                break;
            case "boolean":
                formItem = new BooleanFormItem(props as IBooleanFormItemProps);
                break;
            case "date":
                formItem = new DateFormItem(props as IDateFormItemProps);
                break;
            case "file":
                formItem = new FileFormItem(props as IFileFormItemProps);
                break;
            case "map_location":
                formItem = new MapLocationFormItem(props as IMapLocationFormItemProps);
                break;
            case "group":
                formItem = new GroupFormItem(props as IGroupFormItemProps);
                break;
            case "repeater":
                formItem = new RepeaterFormItem(props as IRepeaterFormItemProps);
                break;
            case "array":
                formItem = new ArrayFormItem(props as IArrayFormItemProps);
                break;
            case "none":
            default:
                formItem = new NoneFormItem(props as INoneFormItemProps);
                break;
        }
        if(activate){
            formItem.active = true;
        }
        this.formItems[formItem.itemID] = formItem;
        return formItem;
    }

    checkRemoveGeneralMessages()
    {
        if(!this.lastGeneralMessagesSetAt || ((new Date()).getTime() - 2000 < this.lastGeneralMessagesSetAt.getTime())){
            return;
        }
        this.lastGeneralMessagesSetAt = null;
        this.errorTexts.length = 0;
        this.successMessage = "";
        this.refreshState();
    }

    addStateChangeListeners()
    {
        super.addStateChangeListeners();
        if(this.hideGeneralMessagesOnClick){
            eventBus.on("site.base-click", this.checkRemoveGeneralMessages);
        }
    }

    removeStateChangeListeners()
    {
        super.removeStateChangeListeners();
        eventBus.remove("site.base-click", this.checkRemoveGeneralMessages);
        this.onValueRenderCallbacks.length = 0;
    }

    initSubmitState()
    {
        super.initSubmitState();
        this.formDidSubmit = false;
        this.successMessage = "";
        for (let formItemName in this.formItems)
        {
            const formItem = this.formItems[formItemName];
            formItem.errorText = "";
        }
    }
}